import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGlitchComponent } from './simple-icons-glitch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGlitchComponent ],
    exports:      [ SimpleIconsGlitchComponent ],
    bootstrap:    []
})
export class SimpleIconsGlitchModule {}
